import InsightImage from '../InsightImage';
import type { InsightImageBlock } from '../../types';

type ImageBlockProps = {
  block: InsightImageBlock;
  accent: string;
  surface: string;
};

export default function ImageBlock({ block, accent, surface }: ImageBlockProps) {
  return (
    <InsightImage
      src={block.imageUrl}
      alt={block.alt}
      caption={block.caption}
      width={block.width ?? 'wide'}
      fit={block.fit ?? 'cover'}
      minHeight={block.fit === 'contain' ? 0 : 340}
      rounded={28}
      accent={accent}
      surface={surface}
      fallbackLabel="Editorial image"
    />
  );
}
